"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _formatNumber = _interopRequireDefault(require("../../util/formatNumber"));
var _reactRedux = require("react-redux");
var _reactI18next = require("react-i18next");
var _updateSubscription = _interopRequireDefault(require("../../api/Customer/updateSubscription"));
var _planHelper = require("../../util/planHelper");
var _checkmarkBase = _interopRequireDefault(require("../../assets/images/checkmarkBase"));
var _planDetailsSlice = require("../../redux/planDetailsSlice");
var _popupSlice = require("../../redux/popupSlice");
var _Button = _interopRequireDefault(require("../Button"));
var _InnerPopupWrapper = _interopRequireDefault(require("../InnerPopupWrapper"));
var _Loader = _interopRequireDefault(require("../Loader"));
var _InnerPopupWrapperStyled = require("../InnerPopupWrapper/InnerPopupWrapperStyled");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const Resubscribe = () => {
  const [isLoading, setIsLoading] = (0, _react.useState)(false);
  const [isError, setIsError] = (0, _react.useState)(false);
  const [currentStep, setCurrentStep] = (0, _react.useState)(1);
  const {
    updateSubscription: {
      offerData: offerDetails
    }
  } = (0, _reactRedux.useSelector)(state => state.popupManager);
  const dispatch = (0, _reactRedux.useDispatch)();
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  const {
    expiresAt,
    nextPaymentPrice,
    nextPaymentCurrency
  } = offerDetails;
  const currencySymbol = _planHelper.currencyFormat[nextPaymentCurrency];
  const formattedNextPaymentPrice = (0, _formatNumber.default)(nextPaymentPrice);
  const resubscribe = async () => {
    window.dispatchEvent(new CustomEvent('MSSDK:resume-action-confirmed', {
      detail: {
        offerId: offerDetails.offerId
      }
    }));
    try {
      setIsLoading(true);
      const response = await (0, _updateSubscription.default)({
        offerId: offerDetails.offerId,
        status: 'active'
      });
      if (response.errors.length) {
        setIsLoading(false);
        setIsError(true);
      } else {
        setIsLoading(false);
        setCurrentStep(2);
      }
    } catch {
      setIsError(true);
      setIsLoading(false);
    }
  };
  const cancelResubscribeAction = () => {
    window.dispatchEvent(new CustomEvent('MSSDK:resume-action-cancelled'));
    dispatch((0, _popupSlice.hidePopup)());
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_InnerPopupWrapper.default, {
    steps: 2,
    popupTitle: t('resubscribe-popup.title', 'Manage your plan'),
    isError: isError,
    currentStep: currentStep,
    children: currentStep === 1 ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_InnerPopupWrapperStyled.ContentStyled, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_InnerPopupWrapperStyled.TitleStyled, {
          children: t('resubscribe-popup.resume-plan', 'Resume your plan')
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_InnerPopupWrapperStyled.TextStyled, {
          children: [t('resubscribe-popup.resume-plan-button-info', 'By clicking the button below you can resume your plan. Your next bill will be on'), ' ', /*#__PURE__*/(0, _jsxRuntime.jsxs)("b", {
            children: [expiresAt === _planHelper.INFINITE_DATE ? t('resubscribe-popup.next-season-start', 'the next season start') : (0, _planHelper.dateFormat)(expiresAt), ' ']
          }), t('resubscribe-popup.it-will-be', 'and it will be'), ' ', /*#__PURE__*/(0, _jsxRuntime.jsx)("b", {
            children: "".concat(currencySymbol).concat(formattedNextPaymentPrice)
          }), "."]
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_InnerPopupWrapperStyled.ButtonWrapperStyled, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, {
          theme: "simple",
          onClickFn: () => cancelResubscribeAction(),
          children: t('resubscribe-popup.no-thanks', 'No, thanks')
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, {
          theme: "confirm",
          onClickFn: resubscribe,
          disabled: isLoading,
          children: isLoading && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Loader.default, {
            buttonLoader: true,
            color: "#ffffff"
          }) || t('resubscribe-popup.resume', 'Resume')
        })]
      })]
    }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)(_InnerPopupWrapperStyled.ContentStyled, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
        src: _checkmarkBase.default,
        alt: "checkmark icon"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_InnerPopupWrapperStyled.TitleStyled, {
        children: t('resubscribe-popup.success.title', 'Your plan has been renewed')
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_InnerPopupWrapperStyled.TextStyled, {
        children: [t('resubscribe-popup.success.description', 'You have been successfully resubscribed. Your fee will be'), ' ', /*#__PURE__*/(0, _jsxRuntime.jsx)("b", {
          children: "".concat(currencySymbol).concat(formattedNextPaymentPrice)
        }), ' ', t('resubscribe-popup.started-from', 'started from'), ' ', /*#__PURE__*/(0, _jsxRuntime.jsxs)("b", {
          children: [expiresAt === _planHelper.INFINITE_DATE ? t('resubscribe-popup.next-season-start', 'the next season start') : (0, _planHelper.dateFormat)(expiresAt), "."]
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, {
        width: "auto",
        margin: "30px auto 0 auto",
        onClickFn: () => {
          dispatch((0, _popupSlice.hidePopup)());
          dispatch((0, _planDetailsSlice.updateList)());
        },
        children: t('resubscribe-popup.back-button', 'Back to My Account')
      })]
    })
  });
};
var _default = exports.default = Resubscribe;